export default __webpack_public_path__ + "static/media/courage.3e95c093.jpg";